import { styled } from '@mui/material/styles';
import { Toolbar, SaveButton } from 'react-admin';
import { Button } from '@mui/material';
import { TURN_STYLES } from '@/styles/theme';

export const ToolbarStyled = styled(Toolbar)(({ theme }) => ({
  justifyContent: 'flex-start',
  gap: 20,
  width: '100%',

  backgroundColor: theme.palette.mode === 'dark' ? TURN_STYLES.darkSurfaceColor : TURN_STYLES.surfaceColor,

  backgroundImage:
    theme.palette.mode === 'dark' ? 'linear-gradient(rgba(255, 255, 255, 0.05), rgba(255, 255, 255, 0.05))' : 'none',

  borderTop: `1px solid ${theme.palette.mode === 'dark' ? TURN_STYLES.darkBorderColor : TURN_STYLES.borderColor}`,
}));

export const SaveButtonStyled = styled(SaveButton)(({ theme }) => ({
  backgroundColor: TURN_STYLES.primaryAccentColor,
  color: '#fff',

  '&:hover': {
    backgroundColor: TURN_STYLES.primaryAccentColor,
    color: '#fff',
  },

  '&.Mui-disabled': {
    backgroundColor: 'rgba(0, 0, 0, 0.12)',
  },
}));

export const CancelButtonStyled = styled(Button)(({ theme }) => ({
  fontWeight: 'bold',
  color: TURN_STYLES.secondaryButtonColor,
}));
